import http from "@/common/http"

export const detail = (code,childCode) =>{
  return http({
    url:"/option/params/detail",
    method:"get",
    data:{
      code,childCode
    }
  })
}

export default {
  detail
}


// WEBPACK FOOTER //
// ./src/services/client/option/params.js